import { Injectable } from '@angular/core';
import {Objeto} from './objeto-generico';

@Injectable()
export class EstadosService {
    EstadosLiquidacion : Objeto[];
    TipoIngreso: Objeto[];
    TipoSiniestro: Objeto[];
    EstadosSinTracking : Objeto[];
    EstadosPreTracking: Objeto[];
    EstadosCobTracking: Objeto[];
    TipoFechaTracking: Objeto[];
    TipoTracking: Objeto[];
    EstadosTracking: Objeto[];
    Meses: Objeto[];


    EstadosNotTracking: Objeto[];
    constructor() {
        this.EstadosLiquidacion = [];
        this.EstadosLiquidacion.push({Nombre : "En Liquidación", Id : 1});
        this.EstadosLiquidacion.push({Nombre : "Cerrado/Pagado", Id : 2});
        this.EstadosLiquidacion.push({Nombre : "Pendiente Documentos", Id : 3});
        this.EstadosLiquidacion.push({Nombre : "Negado", Id : 4});
        this.EstadosLiquidacion.push({Nombre : "Eliminado", Id : 5});

        this.TipoIngreso = [];
        this.TipoIngreso.push({Nombre : "Manual", Id : 1});
        this.TipoIngreso.push({Nombre : "Importación", Id : 2});
        this.TipoIngreso.push({Nombre : "Migración", Id : 3});

        this.TipoSiniestro = [];
        this.TipoSiniestro.push({Nombre : "Liquidación", Id : 1});
        this.TipoSiniestro.push({Nombre : "Pago Comercial", Id : 2});
        this.TipoSiniestro.push({Nombre : "Siniestro Aseguradora", Id : 3});
        
        this.EstadosSinTracking = [];
        
        this.EstadosSinTracking.push({Nombre : "Enviado Aseguradora", Id : 2});
        // this.EstadosSinTracking.push({Nombre : "Eliminado", Id : 9});
        this.EstadosSinTracking.push({Nombre : "Ingresado", Id : 1});
        this.EstadosSinTracking.push({Nombre : "Pagado", Id : 3});
        this.EstadosSinTracking.push({Nombre : "Cerrado", Id : 4});
        this.EstadosSinTracking.push({Nombre : "Solicitado Documentos", Id : 5});
        

        this.EstadosPreTracking = [];
        this.EstadosPreTracking.push({Nombre : "Ingresado", Id : 1});
        this.EstadosPreTracking.push({Nombre : "Aprobado", Id : 6});
        this.EstadosPreTracking.push({Nombre : "Negado", Id : 7});
        this.EstadosPreTracking.push({Nombre : "Eliminado", Id : 9});

        this.EstadosCobTracking = [];
        this.EstadosCobTracking.push({Nombre : "Ingresado", Id : 1});
        this.EstadosCobTracking.push({Nombre : "Solicitado Pago", Id : 8});
        this.EstadosCobTracking.push({Nombre : "Pagado", Id : 3});
        this.EstadosCobTracking.push({Nombre : "Eliminado", Id : 9});

        this.TipoFechaTracking = [];
        this.TipoFechaTracking.push({Nombre : "Ingreso", Id : 1});
        this.TipoFechaTracking.push({Nombre : "Pago", Id : 2});
        this.TipoFechaTracking.push({Nombre : "Cierre", Id : 2});

        this.TipoTracking = [];
        this.TipoTracking.push({Nombre : "Siniestros", Id : 1});
        this.TipoTracking.push({Nombre : "Preautorizaciones", Id : 2});
        this.TipoTracking.push({Nombre : "Notas de Cobranza", Id : 2});

        this.EstadosTracking=[];
        this.EstadosTracking.push({Nombre : "Ingresado", Id : 1});
        this.EstadosTracking.push({Nombre : "Enviado Aseguradora", Id : 2});
        this.EstadosTracking.push({Nombre : "Pagado", Id : 3});
        this.EstadosTracking.push({Nombre : "Cerrado", Id : 4});
        this.EstadosTracking.push({Nombre : "Solicitado Documentos", Id : 5});
        this.EstadosTracking.push({Nombre : "Aprobado", Id : 6});
        this.EstadosTracking.push({Nombre : "Negado", Id : 7});
        this.EstadosTracking.push({Nombre : "Solicitado Pago", Id : 8});
        this.EstadosTracking.push({Nombre : "Eliminado", Id : 9});
       
        this.EstadosNotTracking = [];
        this.EstadosNotTracking.push({Nombre : "Ingresado", Id : 1});
        this.EstadosNotTracking.push({Nombre : "Solicitar Pago", Id : 8});
        this.EstadosNotTracking.push({Nombre : "Pagado", Id : 3});

        this.Meses = [];
        this.Meses.push({Nombre : "Enero", Id : 1});
        this.Meses.push({Nombre : "Febrero", Id : 2});
        this.Meses.push({Nombre : "Marzo", Id : 3});
        this.Meses.push({Nombre : "Abril", Id : 4});
        this.Meses.push({Nombre : "Mayo", Id : 5});
        this.Meses.push({Nombre : "Junio", Id : 6});
        this.Meses.push({Nombre : "Julio", Id : 7});
        this.Meses.push({Nombre : "Agosto", Id : 8});
        this.Meses.push({Nombre : "Septiembre", Id : 9});
        this.Meses.push({Nombre : "Octubre", Id : 10});
        this.Meses.push({Nombre : "Noviembre", Id : 11});
        this.Meses.push({Nombre : "Diciembre", Id : 12});
        
        
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/utils/estados.service.ts